import { Component, Input } from "@angular/core"
import { Link } from "../../models/link.model"
import { UserService } from "../../services/user.service"

declare var window: any

@Component({
    selector: "app-admin-header",
    templateUrl: "./admin-header.component.html",
    styleUrls: ["./admin-header.component.scss"],
})
export class AdminHeaderComponent {
    @Input() public links: Link[] = []
    @Input() public isUnpublishedPreview: boolean = false
    public version: string | number = window.PBSLM.NG.VERSION || ""

    constructor(public userService: UserService) {}
}
